import { useState } from "react";
import { FaEdit, FaSave, FaTrash } from "react-icons/fa";

const CategoryTable = ({ categories, onSave, onDelete }) => {
  const [editingCategory, setEditingCategory] = useState(null);
  const [newCategory, setNewCategory] = useState("");

  const handleEdit = (category) => {
    setEditingCategory(category);
    setNewCategory(category);
  };

  const handleSave = () => {
    onSave(editingCategory, newCategory);
    setEditingCategory(null);
    setNewCategory("");
  };

  return (
    <table className="m-3 bg-gray-100 rounded-t-lg shadow-lg text-s">
      <tbody>
        {categories.map((category) => (
          <tr key={category} className="hover:bg-gray-50">
            {editingCategory === category ? (
              <>
                <td className="align-middle">
                  <input
                    type="text"
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                    className="w-full p-1 border border-gray-300 rounded-md text-s"
                  />
                </td>
                <td className="grid grid-cols-2 gap-2 grid-flow-col justify-stretch text-center align-middle">
                  <FaSave
                    onClick={handleSave}
                    className="cursor-pointer text-gray-700 self-center m-4 mr-3"
                  />
                  <FaTrash
                    onClick={() => onDelete(category)}
                    className="cursor-pointer text-gray-700 self-center m-4 ml-3"
                  />
                </td>
              </>
            ) : (
              <>
                <td className="py-1 px-2 border-b border-gray-300 text-s">
                  {category}
                </td>
                <td className="py-1 px-2 border-b border-gray-300 text-s">
                  <FaEdit
                    onClick={() => handleEdit(category)}
                    className="cursor-pointer text-gray-700 m-4"
                  />
                </td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CategoryTable;
